import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';

declare var $: any;

export class BaseComponent {


  constructor(public router: Router,
              public translate: TranslateService) {
  }

  showMessage(t: string, m: string, type: any = null) {
    Swal.fire({
      title: t,
      html: m,
      icon: type,
      confirmButtonColor: '#265ba3',
    });
  }

  confirmMessage(t: string, m: string, callback: any = null) {
    Swal.fire({
      title: t,
      text: m,
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      confirmButtonColor: '#265ba3',
      cancelButtonColor: '#dc3545'
    }).then((result) => {
      if (!this.isNullOrUndefined(result.value) && result.value === true) {
        if (callback != null) {
          callback();
        }
      }
    });
  }

  switchLanguage(language: string) {
    if (language === 'pt-BR') {
      language = 'pt';
      this.setCulture('pt-BR');
    } else if (language === 'en-US') {
      language = 'en';
      this.setCulture('en-US');
    } else if (language === 'es-ES') {
      language = 'es';
      this.setCulture('es-ES');
    }
    this.translate.use(language);
  }

  setCulture(culture: string) {
    localStorage.setItem('culture', culture);
  }

  previousStep(currentStep: number) {
    $('#nav-tab').find('a:eq(' + (currentStep - 1) + ')').tab('show');
  }

  nextStep(currentStep: number) {
    $('#nav-tab').find('a:eq(' + (currentStep + 1) + ')').tab('show');
  }

  isNullOrUndefined(value) {
    return typeof value === 'undefined' || value == null || value.length === 0;
  }

  showModal(modalName: string) {
    $('#' + modalName).modal('show');
  }

  closeModal(modalName: string) {
    $('#' + modalName).modal('hide');
  }

  onError(error): any {
    if (error.status === 401) {
      this.router.navigate(['/login']);
      return;
    }

    // const e = JSON.parse(error['error']);

    if (error.status === 400) {
      this.showMessage('Atenção', error.error.message, 'warning');
      return;
    }

    if (error.status === 500) {
      this.showMessage('Atenção', 'Ocorreu um erro.', 'warning');
      return;
    }
  }

  validateField(obj) {
    let strError = ``;
    obj.map((e) => {
      if (this.isNullOrUndefined(e.value)) {
        strError += `${e.text}`;
      }
    });
    return strError;
  }

  isEMailValid(strEmail) {
    const str = strEmail;
    const exp = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    const testResult = exp.test(str);
    if (!testResult) {
      this.showMessage('Atenção', 'Informe um e-mail válido para prosseguir.', 'warning');
    }
    return testResult;
  }

  isCPFValid(strCPF) {
    let Soma;
    let Resto;
    Soma = 0;
    const strErrorTitle = 'Atenção';
    const strErrorDescription = 'Informe um CPF válido para prosseguir.';
    strCPF = strCPF.replace(/\D+/g, '');
    if (strCPF === '00000000000' || strCPF === '12112112155') {
      this.showMessage(strErrorTitle, strErrorDescription, 'warning');
      return false;
    }
    for (let i = 1; i <= 9; i++) {
      // tslint:disable-next-line:radix
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }
    Resto = (Soma * 10) % 11;
    if ((Resto === 10) || (Resto === 11)) {
      Resto = 0;
    }
    // tslint:disable-next-line:radix
    if (Resto !== parseInt(strCPF.substring(9, 10))) {
      this.showMessage(strErrorTitle, strErrorDescription, 'warning');
      return false;
    }
    Soma = 0;
    for (let i = 1; i <= 10; i++) {
      // tslint:disable-next-line:radix
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    }
    Resto = (Soma * 10) % 11;
    if ((Resto === 10) || (Resto === 11)) {
      Resto = 0;
    }
    // tslint:disable-next-line:radix
    if (Resto !== parseInt(strCPF.substring(10, 11))) {
      this.showMessage(strErrorTitle, strErrorDescription, 'warning');
      return false;
    }
    return true;
  }

  toggleLoader(b: boolean): void {
    if (!b) {
      $('#loaderBox').fadeOut();
    } else {
      $('#loaderBox').fadeIn();
    }
  }
}
